import raiders from './theme/raiders';
import defaultTheme from './defaultTheme';

import { merge } from 'lodash';
import {
  white,
  peacockBlue,
} from '@g4/boneyard/lib/theme/colors';
import { grey100 } from './theme/colors';

const raidersTheme = merge({}, defaultTheme, {
  colors: {
    siteHeader: {
      light: {
        linkColor: peacockBlue,
        linkBackground: white,
      },
    },

    siteFooter: {
      background: '#1f1f1f',
      title: white,
      link: white,
      divider: grey100,
      copyright: white,
    },
  },
  raiders,
});

export default raidersTheme;
